<template>
  <Day day="23.12.2022">
    <div slot="page-content">
      <h1 class="headline mb-5 align-center px-5">3, 2, 1</h1>

      <p class="px-5 py-5">
       Már javában folyik a visszaszámlálás, legalább annyira, mint ahogy az arcodon szokottt folyni a ... majonéz. <br />Itt hagyok most Neked egy kis hangulatkeltő éjszakai-fényt:
      </p>
      <iframe src="https://www.pornhub.com/embed/ph5ff5e65455302" frameborder="0" width="560" height="315" scrolling="no" allowfullscreen></iframe>

      
    </div>
  </Day>
</template>
  
  <script>
import Day from "@/views/days/Day.vue";

export default {
  name: "Day18",
  components: {
    Day,
  },
  data() {
    return {
      hover: false,
    };
  },
  mounted() {
    document.body.classList.add("pihi");
  },
  destroyed() {
    document.body.classList.remove("pihi");
  },
};
</script>
  

<style lang="scss">
.italic {
  font-style: italic;
}
p {
  font-size: 1.3em;
  line-height: 1.8;
}
.hover {
  filter: blur(5px);
  transition: filter 500ms ease-in-out;
  cursor: pointer;
  &:hover {
    filter: blur(0);
  }
}
</style>